var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"home content-section"},[_c('el-col',{staticClass:"sidebar",attrs:{"xs":24,"md":6}},[_c('side-menu')],1),_c('el-col',{staticClass:"main-content",attrs:{"xs":24,"md":18}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac651a2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WithSidebar.vue
// module id = null
// module chunks = 